import { render } from "./DrawerMenuView.vue?vue&type=template&id=a7377bc4&scoped=true"
import script from "./DrawerMenuView.vue?vue&type=script&lang=js"
export * from "./DrawerMenuView.vue?vue&type=script&lang=js"

import "./DrawerMenuView.vue?vue&type=style&index=0&id=a7377bc4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7377bc4"]])

export default __exports__